import { render, staticRenderFns } from "./RecursiveOrgChart.vue?vue&type=template&id=0a79d0c2&scoped=true&"
import script from "./RecursiveOrgChart.vue?vue&type=script&lang=js&"
export * from "./RecursiveOrgChart.vue?vue&type=script&lang=js&"
import style0 from "./RecursiveOrgChart.vue?vue&type=style&index=0&id=0a79d0c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a79d0c2",
  null
  
)

export default component.exports